var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckBoxChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.83339 9.45496L4.89748 7.51907C4.7821 7.40368 4.63707 7.34465 4.46239 7.34198C4.28773 7.3393 4.14003 7.39833 4.01931 7.51907C3.89857 7.63979 3.83821 7.78615 3.83821 7.95815C3.83821 8.13015 3.89857 8.27651 4.01931 8.39723L6.30616 10.6841C6.4568 10.8347 6.63255 10.91 6.83339 10.91C7.03424 10.91 7.20998 10.8347 7.36062 10.6841L11.9969 6.04788C12.1122 5.93251 12.1713 5.78748 12.1739 5.6128C12.1766 5.43812 12.1176 5.29041 11.9969 5.16969C11.8761 5.04897 11.7298 4.98861 11.5577 4.98861C11.3857 4.98861 11.2394 5.04897 11.1187 5.16969L6.83339 9.45496ZM2.42316 15.0831C2.00222 15.0831 1.64591 14.9373 1.35425 14.6456C1.06258 14.354 0.916748 13.9977 0.916748 13.5767V2.42292C0.916748 2.00198 1.06258 1.64567 1.35425 1.354C1.64591 1.06234 2.00222 0.916504 2.42316 0.916504H13.577C13.9979 0.916504 14.3542 1.06234 14.6459 1.354C14.9375 1.64567 15.0834 2.00198 15.0834 2.42292V13.5767C15.0834 13.9977 14.9375 14.354 14.6459 14.6456C14.3542 14.9373 13.9979 15.0831 13.577 15.0831H2.42316Z",
    fill: "#F2673A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxChecked);
export default __webpack_public_path__ + "static/media/check_box_checked.0538521160b6d85a30a9a44b2357cd11.svg";
export { ForwardRef as ReactComponent };